import LocalizeInput from 'components/input/LocalizeInput';
import ModifyButtons from 'components/layouts/ModifyButtons';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, UIStore, useModelStateContext } from 'saladsoft-primitive';
import { AdminRegionRequestDto, AdminTagRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import { RegionModel, TagModel } from 'types/CommonTypes';

const RegionForm = ({
  onSave,
  region,
}: {
  onSave: (region?: RegionModel) => void;
  region?: RegionModel;
}) => {
  const { setState, stateModel } = useModelStateContext<AdminTagRequestDto>();
  const { uiStore } = useStoreWrapper();

  const handleClickSave = async () => {
    let result: any;
    if (region?.id) {
      result = await ServiceHelper.adminRegionService?.updateRegion(
        region?.id as number,
        stateModel as AdminRegionRequestDto,
      );
    } else {
      result = await ServiceHelper.adminRegionService?.createRegion(
        stateModel as AdminRegionRequestDto,
      );
    }

    if (result?.status && result.status < 300) {
      uiStore?.modal.close();
      toast.success('지역 추가 완료');
      onSave?.(result.data as RegionModel);
    }
  };

  const handleClickDelete = () => {
    if (region?.id) {
      ServiceHelper.adminRegionService?.deleteRegion(region.id).then((res) => {
        if (res?.status && res.status < 300) {
          toast.success('지역 삭제 완료');
          onSave?.();
          uiStore?.modal.close();
        } else {
          toast.error('지역 삭제 실패');
        }
      });
    }
  };

  useEffect(() => {
    if (region) {
      setState('localizedName', region.localizedName);
    }
  }, [region]);

  return (
    <div>
      <LocalizeInput
        defaultValue={region?.localizedName}
        onChange={(value) => setState('localizedName', value)}
      />
      <ModifyButtons
        type={region?.id ? 'update' : 'create'}
        showDelete={region?.id ? true : false}
        onCancel={() => uiStore?.modal.close()}
        onSave={() => {
          handleClickSave();
        }}
        onDelete={() => {
          handleClickDelete();
        }}
      />
      {/* <Button
        style={{ marginTop: 20 }}
        onClick={async () => {
          if (stateModel) {
            const result = await ServiceHelper.adminTagService?.createTag(stateModel);
            if (result?.status && result.status < 300) {
              uiStore?.modal.close();
              toast.success('태그 추가 완료');
              onSave?.(result.data as TagModel);
            }
          }
        }}
      > */}
    </div>
  );
};

export default RegionForm;
